module.exports = __webpack_public_path__ + "media/images/profile/looking-for-b74b69662b26a61d360279bbde03d902.svg";